import React, { useCallback, useEffect, useState } from 'react';
import handleError from '@/actions/common/handle-error.action';
import BlueButtonWithIcon from '@/components/BlueButtonWithIcon';
import adminApi from '../../../api/api';
import { styled, textAlign } from '@mui/system';
import Memory from '@/components/Memory';
import { Container } from '@/components';

interface DiskUsageRecord {
  path: string;
  title?: string;
  available: number;
  total: number;
  free: number;
  used: number;
  error?: string;
}

async function getDiskSpaceStats(): Promise<DiskUsageRecord[]> {
  const { data } = await adminApi().get<DiskUsageRecord[]>(`dashboards/disk-space-stats`);
  return data;
}

const StatsTable = styled('table')({
  borderCollapse: 'collapse',
  width: '100%',
  tableLayout: 'fixed',
  borderWidth: '1px',
  th: {
    color: 'grey',
    padding: '5px',
  },
  td: {
    padding: '10px',
  },
  ['td.number']: {
      textAlign: 'right',
  }
});

const Widget = styled(Container)({
  display: 'block',
  width: '30%',
  padding: '20px',
  border: 'solid grey 1px',
});

export default () => {
  const [ stats, setStats ] = useState<DiskUsageRecord[] | null>(null);

  const refreshStats = useCallback(() => {
    getDiskSpaceStats().then(setStats).catch(handleError)
  }, []);

  useEffect(() => refreshStats(), []);

  return <Widget>
    <h3>Использование дисков</h3>
    <StatsTable>
      <col width="30%" /><col width="30%" />
      <tr><th>Диск</th><th>Путь</th><th>Емкость</th><th>Свободно</th><th>Занято</th></tr>
      {stats && stats.map(({ title, path, error, used, total, free }, i) =>
        <tr key={`checked_disk${i}`}>
          <td>{title || ''}</td>
          <td>{path}</td>
          {error
            ? (<td colSpan={3}>{error}</td>)
            : (<>
            <td className="number"><Memory value={total} /></td>
            <td className="number"><Memory value={free} /></td>
            <td className="number">{Math.round(used * 1000 / total) / 10}%</td>
            </>)}
        </tr>
      )}
    </StatsTable>
    <Container text-align="right"><BlueButtonWithIcon onClick={refreshStats}>Обновить</BlueButtonWithIcon></Container>
  </Widget>;
};